/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";

/* components */
import formWrapper from "../../shared/Form";
import { TextEditor, TextInput, CheckBox, Tags, FileInput, PublishAtPicker } from "../../shared/Forms/";
import ChangeHistory from "../../shared/ChangeHistory";
import Switcher from "../../ui/Switcher";
import GetItem from "../../../helpers/dataProviders/getItem";
import parseAppKey from "../../../helpers/routeHelpers/parseAppKey";

class PostsForm extends Component {
	constructor(props) {
		super(props);
		this.appKey = parseAppKey();
		this.state = {
			type: this.initialSetup(props),
			postTags: [],
		};
	}

	componentDidMount() {
		this.getPostTags();
	}

	getPostTags = () => {
		GetItem(`/apps/${this.appKey}/posts`).then(data => {
			let postTags = [];
			let tags = {};
			data.data.forEach(item => {
				item.tags.forEach(tag => {
					tags[tag] = tag;
				});
			});
			Object.keys(tags).forEach(tag => {
				postTags.push({
					id: tag,
					label: tag,
				});
			});

			this.setState({ postTags });
		});
	};

	initialSetup = props => {
		let { initialValues } = props;
		if (initialValues) {
			if (initialValues.videoUrl) {
				return "video";
			} else if (initialValues.imageUrl) {
				return "image";
			}
		}
		return "text";
	};

	changeType = (index, option) => {
		this.setState({ type: option.value });
	};

	render() {
		const { postTags } = this.state;
		const switcherOptions = [
			{ label: "Text", value: "text" },
			{ label: "Image", value: "image" },
			{ label: "Video", value: "video" },
		];
		const { actionType, id } = this.props;
		return (
			<div>
				{actionType === "update" && !!id && <ChangeHistory entity="posts" id={id} />}
				<Switcher initialValue={this.state.type} options={switcherOptions} onSelect={this.changeType} />
				<div className="switcher-well">
					{this.state.type === "video" && (
						<React.Fragment>
							<FileInput field="imageUrl" id="imageUrl" placeholder="Video Poster" autocomplete="off" />
							<TextInput field="videoUrl" id="videoUrl" placeholder="Video URL" autocomplete="off" />
						</React.Fragment>
					)}
					{this.state.type === "image" && (
						<FileInput field="imageUrl" id="imageUrl" placeholder="Image URL" autocomplete="off" />
					)}
					<TextEditor
						isRequired
						field="text"
						id="text"
						buttonOptions={["a"]}
						placeholder="Text"
						autoComplete="off"
					/>
				</div>
				<Tags
					field="tags"
					id="tags"
					placeholder="Tags"
					allowNew
					dataObjects={postTags}
					dataObjectKey="id"
					dataObjectLabel="label"
					minQueryLength={1}
				/>
				<PublishAtPicker field="publishAt" id="publishAt" placeholder="Publish Date" />
				<div className="row">
					<div className="col-sm-6">
						<CheckBox field="isShareable" id="isShareable" label="Shareable" textalign="center" />
					</div>
				</div>
				{this.props.values.isShareable && (
					<TextInput field="shareUrl" id="shareUrl" placeholder="Share URL" autocomplete="off" />
				)}
				<div className="btn btn-success" onClick={() => this.props.submitForm(true)}>
					{this.props.buttonLabel}
				</div>
			</div>
		);
	}
}

PostsForm.propTypes = {
	values: PropTypes.object,
	initialValues: PropTypes.object,
	cultures: PropTypes.array,
	buttonLabel: PropTypes.string,
	showExtraFields: PropTypes.bool,
	actionType: PropTypes.string,
	id: PropTypes.string,
	submitForm: PropTypes.func,
};

export default formWrapper(PostsForm);
